module.exports = __webpack_public_path__ + "static/media/insta-grey.ed4fc785.svg";